/**
 * Wallpaper Builder Config — MOOUI
 * @author Fabiano Omura — Mooui Labs
 * @copyright 2026 Mooui Labs. All rights reserved.
 */


window.WALLPAPER_CONFIG = {

  // 12 Cores disponíveis (nome + código hexadecimal)
  // ID comercial = nome exibido no front
  colors: [
    { id: 'offwhite', name: 'Off White', hex: '#FBF8F6' },
    { id: 'creme', name: 'Creme', hex: '#FBF5E3' },
    { id: 'rosa-docura', name: 'Rosa Doçura', hex: '#F5C5C2' },
    { id: 'cereja', name: 'Cereja', hex: '#CD363E' },
    { id: 'marsala', name: 'Marsala', hex: '#A32D4F' },
    { id: 'amarelo-radiante', name: 'Amarelo Radiante', hex: '#FFDE93' },
    { id: 'mostarda', name: 'Mostarda', hex: '#C68E51' },
    { id: 'menta', name: 'Menta', hex: '#D6E8D7' },
    { id: 'pinheiro', name: 'Pinheiro', hex: '#266E48' },
    { id: 'petroleo', name: 'Petróleo', hex: '#346F8B' },
    { id: 'azul-ceu', name: 'Azul Céu', hex: '#A3D2EE' },
    { id: 'lilas', name: 'Lilás', hex: '#D2C5DA' }
  ],

  // 2 Larguras de faixa disponíveis
  stripeWidths: [
    { id: 'fina', name: 'Listra Fina', width: 2, unit: 'cm', totalStripes: 26 },
    { id: 'larga', name: 'Listra Larga', width: 10, unit: 'cm', totalStripes: 10 }
  ],

  // Padrão de SKU
  // Formato: PPL-[LARGURA]-[COR1]-[COR2]
  // Usa IDs de cores completos para evitar colisões (ex: AZUL-CEU, PETROLEO)
  // A posição importa: PPL-FIN-ROSA-DOÇURA-CREME ≠ PPL-FIN-CREME-ROSA-CLARO
  generateSKU: function(stripeWidth, color1, color2) {
    const widthCode = { 'fina': 'FIN', 'larga': 'LAR' }[stripeWidth];
    const sku = `PPL-${widthCode}-${color1.toUpperCase()}-${color2.toUpperCase()}`;
    return sku;
  },

  // Mapa de produtos: SKU → variantId do Shopify + TOTVS SKU (regenerado 2026-05-18)
  // 132 produtos (66 listra fina + 66 listra larga)
  WALLPAPER_PRODUCTS: {
    "PPL-FIN-AMARELO-RADIANTE-AZUL-CEU": { variantId: 54165719482714, totvsSku: "15783" },
    "PPL-FIN-AMARELO-RADIANTE-LILAS": { variantId: 54165719515482, totvsSku: "15784" },
    "PPL-FIN-AMARELO-RADIANTE-MENTA": { variantId: 54165719581018, totvsSku: "15780" },
    "PPL-FIN-AMARELO-RADIANTE-MOSTARDA": { variantId: 54165719810394, totvsSku: "15779" },
    "PPL-FIN-AMARELO-RADIANTE-PETROLEO": { variantId: 54165719843162, totvsSku: "15782" },
    "PPL-FIN-AMARELO-RADIANTE-PINHEIRO": { variantId: 54165720072538, totvsSku: "15781" },
    "PPL-FIN-AZUL-CEU-LILAS": { variantId: 54165720105306, totvsSku: "15799" },
    "PPL-FIN-CEREJA-AMARELO-RADIANTE": { variantId: 54165720203610, totvsSku: "15765" },
    "PPL-FIN-CEREJA-AZUL-CEU": { variantId: 54165720301914, totvsSku: "15770" },
    "PPL-FIN-CEREJA-LILAS": { variantId: 54165720334682, totvsSku: "15771" },
    "PPL-FIN-CEREJA-MARSALA": { variantId: 54165720367450, totvsSku: "15764" },
    "PPL-FIN-CEREJA-MENTA": { variantId: 54165720432986, totvsSku: "15767" },
    "PPL-FIN-CEREJA-MOSTARDA": { variantId: 54165720498522, totvsSku: "15766" },
    "PPL-FIN-CEREJA-PETROLEO": { variantId: 54165720564058, totvsSku: "15769" },
    "PPL-FIN-CEREJA-PINHEIRO": { variantId: 54165720596826, totvsSku: "15768" },
    "PPL-FIN-CREME-AMARELO-RADIANTE": { variantId: 54165722923354, totvsSku: "15748" },
    "PPL-FIN-CREME-AZUL-CEU": { variantId: 54165723283802, totvsSku: "15753" },
    "PPL-FIN-CREME-CEREJA": { variantId: 54165724299610, totvsSku: "15746" },
    "PPL-FIN-CREME-LILAS": { variantId: 54165724823898, totvsSku: "15754" },
    "PPL-FIN-CREME-MARSALA": { variantId: 54165726134618, totvsSku: "15747" },
    "PPL-FIN-CREME-MENTA": { variantId: 54165726200154, totvsSku: "15750" },
    "PPL-FIN-CREME-MOSTARDA": { variantId: 54165726298458, totvsSku: "15749" },
    "PPL-FIN-CREME-PETROLEO": { variantId: 54165726331226, totvsSku: "15752" },
    "PPL-FIN-CREME-PINHEIRO": { variantId: 54165726396762, totvsSku: "15751" },
    "PPL-FIN-CREME-ROSA-DOCURA": { variantId: 54165726462298, totvsSku: "15745" },
    "PPL-FIN-MARSALA-AMARELO-RADIANTE": { variantId: 54165726527834, totvsSku: "15772" },
    "PPL-FIN-MARSALA-AZUL-CEU": { variantId: 54165726560602, totvsSku: "15777" },
    "PPL-FIN-MARSALA-LILAS": { variantId: 54165726626138, totvsSku: "15778" },
    "PPL-FIN-MARSALA-MENTA": { variantId: 54165726658906, totvsSku: "15774" },
    "PPL-FIN-MARSALA-MOSTARDA": { variantId: 54165726691674, totvsSku: "15773" },
    "PPL-FIN-MARSALA-PETROLEO": { variantId: 54165726724442, totvsSku: "15776" },
    "PPL-FIN-MARSALA-PINHEIRO": { variantId: 54165726757210, totvsSku: "15775" },
    "PPL-FIN-MENTA-AZUL-CEU": { variantId: 54165726789978, totvsSku: "15792" },
    "PPL-FIN-MENTA-LILAS": { variantId: 54165726888282, totvsSku: "15793" },
    "PPL-FIN-MENTA-PETROLEO": { variantId: 54165726953818, totvsSku: "15791" },
    "PPL-FIN-MENTA-PINHEIRO": { variantId: 54165726986586, totvsSku: "15790" },
    "PPL-FIN-MOSTARDA-AZUL-CEU": { variantId: 54165727052122, totvsSku: "15788" },
    "PPL-FIN-MOSTARDA-LILAS": { variantId: 54165729444186, totvsSku: "15789" },
    "PPL-FIN-MOSTARDA-MENTA": { variantId: 54165729575258, totvsSku: "15785" },
    "PPL-FIN-MOSTARDA-PETROLEO": { variantId: 54165729640794, totvsSku: "15787" },
    "PPL-FIN-MOSTARDA-PINHEIRO": { variantId: 54165729673562, totvsSku: "15786" },
    "PPL-FIN-OFFWHITE-AMARELO-RADIANTE": { variantId: 54165729706330, totvsSku: "15738" },
    "PPL-FIN-OFFWHITE-AZUL-CEU": { variantId: 54165730034010, totvsSku: "15743" },
    "PPL-FIN-OFFWHITE-CEREJA": { variantId: 54165730132314, totvsSku: "15736" },
    "PPL-FIN-OFFWHITE-CREME": { variantId: 54165730230618, totvsSku: "15734" },
    "PPL-FIN-OFFWHITE-LILAS": { variantId: 54165730296154, totvsSku: "15744" },
    "PPL-FIN-OFFWHITE-MARSALA": { variantId: 54165730361690, totvsSku: "15737" },
    "PPL-FIN-OFFWHITE-MENTA": { variantId: 54165730427226, totvsSku: "15740" },
    "PPL-FIN-OFFWHITE-MOSTARDA": { variantId: 54165730558298, totvsSku: "15739" },
    "PPL-FIN-OFFWHITE-PETROLEO": { variantId: 54165730591066, totvsSku: "15742" },
    "PPL-FIN-OFFWHITE-PINHEIRO": { variantId: 54165730951514, totvsSku: "15741" },
    "PPL-FIN-OFFWHITE-ROSA-DOCURA": { variantId: 54165731017050, totvsSku: "15735" },
    "PPL-FIN-PETROLEO-AZUL-CEU": { variantId: 54165731508570, totvsSku: "15797" },
    "PPL-FIN-PETROLEO-LILAS": { variantId: 54165731705178, totvsSku: "15798" },
    "PPL-FIN-PINHEIRO-AZUL-CEU": { variantId: 54165731836250, totvsSku: "15795" },
    "PPL-FIN-PINHEIRO-LILAS": { variantId: 54165731934554, totvsSku: "15796" },
    "PPL-FIN-PINHEIRO-PETROLEO": { variantId: 54165731967322, totvsSku: "15794" },
    "PPL-FIN-ROSA-DOCURA-AMARELO-RADIANTE": { variantId: 54165732032858, totvsSku: "15757" },
    "PPL-FIN-ROSA-DOCURA-AZUL-CEU": { variantId: 54165732131162, totvsSku: "15762" },
    "PPL-FIN-ROSA-DOCURA-CEREJA": { variantId: 54165732229466, totvsSku: "15755" },
    "PPL-FIN-ROSA-DOCURA-LILAS": { variantId: 54165735014746, totvsSku: "15763" },
    "PPL-FIN-ROSA-DOCURA-MARSALA": { variantId: 54165735178586, totvsSku: "15756" },
    "PPL-FIN-ROSA-DOCURA-MENTA": { variantId: 54165735244122, totvsSku: "15759" },
    "PPL-FIN-ROSA-DOCURA-MOSTARDA": { variantId: 54165735276890, totvsSku: "15758" },
    "PPL-FIN-ROSA-DOCURA-PETROLEO": { variantId: 54165735506266, totvsSku: "15761" },
    "PPL-FIN-ROSA-DOCURA-PINHEIRO": { variantId: 54165735571802, totvsSku: "15760" },
    "PPL-LAR-AMARELO-RADIANTE-AZUL-CEU": { variantId: 54165735702874, totvsSku: "15849" },
    "PPL-LAR-AMARELO-RADIANTE-LILAS": { variantId: 54165735833946, totvsSku: "15850" },
    "PPL-LAR-AMARELO-RADIANTE-MENTA": { variantId: 54165735866714, totvsSku: "15846" },
    "PPL-LAR-AMARELO-RADIANTE-MOSTARDA": { variantId: 54165736030554, totvsSku: "15845" },
    "PPL-LAR-AMARELO-RADIANTE-PETROLEO": { variantId: 54165736128858, totvsSku: "15848" },
    "PPL-LAR-AMARELO-RADIANTE-PINHEIRO": { variantId: 54165736194394, totvsSku: "15847" },
    "PPL-LAR-AZUL-CEU-LILAS": { variantId: 54165736259930, totvsSku: "15865" },
    "PPL-LAR-CEREJA-AMARELO-RADIANTE": { variantId: 54165736358234, totvsSku: "15831" },
    "PPL-LAR-CEREJA-AZUL-CEU": { variantId: 54165736456538, totvsSku: "15836" },
    "PPL-LAR-CEREJA-LILAS": { variantId: 54165736980826, totvsSku: "15837" },
    "PPL-LAR-CEREJA-MARSALA": { variantId: 54165737046362, totvsSku: "15830" },
    "PPL-LAR-CEREJA-MENTA": { variantId: 54165737341274, totvsSku: "15833" },
    "PPL-LAR-CEREJA-MOSTARDA": { variantId: 54165737406810, totvsSku: "15832" },
    "PPL-LAR-CEREJA-PETROLEO": { variantId: 54165737505114, totvsSku: "15835" },
    "PPL-LAR-CEREJA-PINHEIRO": { variantId: 54165737570650, totvsSku: "15834" },
    "PPL-LAR-CREME-AMARELO-RADIANTE": { variantId: 54165737668954, totvsSku: "15814" },
    "PPL-LAR-CREME-AZUL-CEU": { variantId: 54165737734490, totvsSku: "15819" },
    "PPL-LAR-CREME-CEREJA": { variantId: 54165740323162, totvsSku: "15812" },
    "PPL-LAR-CREME-LILAS": { variantId: 54165740388698, totvsSku: "15820" },
    "PPL-LAR-CREME-MARSALA": { variantId: 54165740519770, totvsSku: "15813" },
    "PPL-LAR-CREME-MENTA": { variantId: 54165740683610, totvsSku: "15816" },
    "PPL-LAR-CREME-MOSTARDA": { variantId: 54165740749146, totvsSku: "15815" },
    "PPL-LAR-CREME-PETROLEO": { variantId: 54165740814682, totvsSku: "15818" },
    "PPL-LAR-CREME-PINHEIRO": { variantId: 54165740912986, totvsSku: "15817" },
    "PPL-LAR-CREME-ROSA-DOCURA": { variantId: 54165740978522, totvsSku: "15811" },
    "PPL-LAR-MARSALA-AMARELO-RADIANTE": { variantId: 54165741011290, totvsSku: "15838" },
    "PPL-LAR-MARSALA-AZUL-CEU": { variantId: 54165741076826, totvsSku: "15843" },
    "PPL-LAR-MARSALA-LILAS": { variantId: 54165741142362, totvsSku: "15844" },
    "PPL-LAR-MARSALA-MENTA": { variantId: 54165741535578, totvsSku: "15840" },
    "PPL-LAR-MARSALA-MOSTARDA": { variantId: 54165741633882, totvsSku: "15839" },
    "PPL-LAR-MARSALA-PETROLEO": { variantId: 54165741764954, totvsSku: "15842" },
    "PPL-LAR-MARSALA-PINHEIRO": { variantId: 54165741863258, totvsSku: "15841" },
    "PPL-LAR-MENTA-AZUL-CEU": { variantId: 54165741961562, totvsSku: "15858" },
    "PPL-LAR-MENTA-LILAS": { variantId: 54165742027098, totvsSku: "15859" },
    "PPL-LAR-MENTA-PETROLEO": { variantId: 54165742158170, totvsSku: "15857" },
    "PPL-LAR-MENTA-PINHEIRO": { variantId: 54165742223706, totvsSku: "15856" },
    "PPL-LAR-MOSTARDA-AZUL-CEU": { variantId: 54165742289242, totvsSku: "15854" },
    "PPL-LAR-MOSTARDA-LILAS": { variantId: 54165742354778, totvsSku: "15855" },
    "PPL-LAR-MOSTARDA-MENTA": { variantId: 54165742420314, totvsSku: "15851" },
    "PPL-LAR-MOSTARDA-PETROLEO": { variantId: 54165742518618, totvsSku: "15853" },
    "PPL-LAR-MOSTARDA-PINHEIRO": { variantId: 54165742715226, totvsSku: "15852" },
    "PPL-LAR-OFFWHITE-AMARELO-RADIANTE": { variantId: 54165742747994, totvsSku: "15804" },
    "PPL-LAR-OFFWHITE-AZUL-CEU": { variantId: 54165742813530, totvsSku: "15809" },
    "PPL-LAR-OFFWHITE-CEREJA": { variantId: 54165742977370, totvsSku: "15802" },
    "PPL-LAR-OFFWHITE-CREME": { variantId: 54165743042906, totvsSku: "15800" },
    "PPL-LAR-OFFWHITE-LILAS": { variantId: 54165743075674, totvsSku: "15810" },
    "PPL-LAR-OFFWHITE-MARSALA": { variantId: 54165743206746, totvsSku: "15803" },
    "PPL-LAR-OFFWHITE-MENTA": { variantId: 54165743305050, totvsSku: "15806" },
    "PPL-LAR-OFFWHITE-MOSTARDA": { variantId: 54165743534426, totvsSku: "15805" },
    "PPL-LAR-OFFWHITE-PETROLEO": { variantId: 54165743599962, totvsSku: "15808" },
    "PPL-LAR-OFFWHITE-PINHEIRO": { variantId: 54165743731034, totvsSku: "15807" },
    "PPL-LAR-OFFWHITE-ROSA-DOCURA": { variantId: 54165743796570, totvsSku: "15801" },
    "PPL-LAR-PETROLEO-AZUL-CEU": { variantId: 54165743894874, totvsSku: "15863" },
    "PPL-LAR-PETROLEO-LILAS": { variantId: 54165744025946, totvsSku: "15864" },
    "PPL-LAR-PINHEIRO-AZUL-CEU": { variantId: 54165744124250, totvsSku: "15861" },
    "PPL-LAR-PINHEIRO-LILAS": { variantId: 54165744255322, totvsSku: "15862" },
    "PPL-LAR-PINHEIRO-PETROLEO": { variantId: 54165744648538, totvsSku: "15860" },
    "PPL-LAR-ROSA-DOCURA-AMARELO-RADIANTE": { variantId: 54165744714074, totvsSku: "15823" },
    "PPL-LAR-ROSA-DOCURA-AZUL-CEU": { variantId: 54165744779610, totvsSku: "15828" },
    "PPL-LAR-ROSA-DOCURA-CEREJA": { variantId: 54165744845146, totvsSku: "15821" },
    "PPL-LAR-ROSA-DOCURA-LILAS": { variantId: 54165744976218, totvsSku: "15829" },
    "PPL-LAR-ROSA-DOCURA-MARSALA": { variantId: 54165745172826, totvsSku: "15822" },
    "PPL-LAR-ROSA-DOCURA-MENTA": { variantId: 54165745303898, totvsSku: "15825" },
    "PPL-LAR-ROSA-DOCURA-MOSTARDA": { variantId: 54165745598810, totvsSku: "15824" },
    "PPL-LAR-ROSA-DOCURA-PETROLEO": { variantId: 54165746123098, totvsSku: "15827" },
    "PPL-LAR-ROSA-DOCURA-PINHEIRO": { variantId: 54165746286938, totvsSku: "15826" },
  },

  // Retorna os dados do produto para a combinação exata escolhida pelo cliente.
  // Procura em ambas as ordens: color1-color2 e color2-color1 (por compatibilidade)
  getProduct: function(stripeWidth, color1, color2) {
    const sku1 = window.WALLPAPER_CONFIG.generateSKU(stripeWidth, color1, color2);
    let product = window.WALLPAPER_CONFIG.WALLPAPER_PRODUCTS[sku1];


    // Se não encontrar, tenta a ordem invertida
    if (!product) {
      const sku2 = window.WALLPAPER_CONFIG.generateSKU(stripeWidth, color2, color1);
      product = window.WALLPAPER_CONFIG.WALLPAPER_PRODUCTS[sku2];
    }

    return product || null;
  },

  // Preço fixo para simulação (pode variar por largura depois)
  basePrice: 337, // R$ 3,37 em centavos (por rolo)

  // Informações do produto
  productInfo: {
    material: {
      title: 'MATERIAL',
      content: `
        <p><strong>Papel de Parede Non-woven (TNT)</strong></p>
        <ul>
          <li>Material: TNT (Tecido Não Tecido) de alta qualidade</li>
          <li>Acabamento: Fosco</li>
          <li>Gramatura: 150g/m²</li>
          <li>Resistência: Alta durabilidade e resistência ao desbotamento</li>
          <li>Instalação: Fácil aplicação, cola aplicada diretamente na parede</li>
          <li>Limpeza: Pode ser limpo com pano úmido</li>
          <li>Certificação: Produto atóxico e seguro para ambientes infantis</li>
        </ul>
      `
    },

    medidas: {
      title: 'MEDIDAS',
      content: `
        <p><strong>Dimensões do Rolo</strong></p>
        <ul>
          <li>Largura: 60cm</li>
          <li>Comprimento: 3 metros (por rolo)</li>
          <li>Área de cobertura: 1,8m² por rolo</li>
          <li>Rapport (repetição do desenho): Varia conforme largura da faixa escolhida</li>
        </ul>
        <p><strong>Cálculo de quantidade:</strong></p>
        <p>Para calcular quantos rolos você precisa, meça a altura e largura da parede e divida pela área de cobertura (1,8m²). Recomendamos adicionar 10% de margem para recortes.</p>
      `
    },

    descricao: {
      title: 'DESCRIÇÃO',
      content: `
        <p><strong>Papel de Parede Listrado Personalizado MOOUI</strong></p>
        <p>Crie um ambiente único e especial com nosso papel de parede listrado totalmente customizável!
        Escolha as cores das faixas e a largura que mais combinam com o seu projeto.</p>

        <h4>Características:</h4>
        <ul>
          <li>✨ Personalizável: Escolha 2 cores entre 12 opções disponíveis</li>
          <li>📏 2 larguras de listra: Fina ou Larga</li>
          <li>🎨 Impressão digital de alta qualidade</li>
          <li>🏠 Ideal para quartos infantis, salas e áreas de convivência</li>
          <li>♻️ Material ecológico e sustentável</li>
          <li>🇧🇷 Produzido sob encomenda no Brasil</li>
        </ul>

        <h4>⏱️ Prazo de Produção:</h4>
        <p><strong>30 dias úteis</strong> após a confirmação do pedido e aprovação do pagamento.</p>
        <p>Por se tratar de um produto personalizado e feito sob encomenda, o prazo de produção
        não pode ser reduzido. Planeje sua compra com antecedência!</p>

        <h4>🎯 Como Funciona:</h4>
        <ol>
          <li>Escolha a largura da listra (Fina ou Larga)</li>
          <li>Selecione a cor 1 (cor base)</li>
          <li>Selecione a cor 2 (cor da listra)</li>
          <li>Visualize o preview em tempo real</li>
          <li>Aceite os termos de produto personalizado</li>
          <li>Adicione ao carrinho</li>
        </ol>
      `
    },

    freteEDevolucao: {
      title: 'FRETE & DEVOLUÇÃO',
      content: `
        <h4>📦 Frete</h4>
        <p>O frete é calculado automaticamente no carrinho com base no seu CEP.</p>
        <ul>
          <li>Enviamos para todo o Brasil via Correios ou transportadora</li>
          <li>O prazo de entrega começa a contar após o término da produção (30 dias úteis)</li>
          <li>Você receberá o código de rastreamento por e-mail</li>
        </ul>

        <h4>🚫 Política de Devolução</h4>
        <p><strong>IMPORTANTE: Não aceitamos trocas ou devoluções de produtos personalizados.</strong></p>
        <p>Por se tratar de um item feito sob encomenda com as cores e especificações escolhidas por você,
        não é possível realizar trocas, devoluções ou cancelamentos após a confirmação do pedido.</p>

        <p><strong>Exceções:</strong></p>
        <ul>
          <li>Defeitos de fabricação comprovados</li>
          <li>Produto danificado durante o transporte (comunicar em até 48h após recebimento)</li>
          <li>Divergência entre o produto recebido e o pedido confirmado</li>
        </ul>

        <h4>⚠️ Atenção</h4>
        <p>Confira atentamente as cores selecionadas antes de finalizar o pedido.
        As cores podem variar levemente dependendo da calibração do seu monitor.</p>
      `
    }
  },

  // Termo de consentimento
  termoConsentimento: {
    text: `Estou ciente de que este é um produto personalizado feito sob encomenda,
           com prazo de produção de 30 dias úteis, e que não aceita trocas ou devoluções.`,
    required: true
  }
};

